<script>
  import makeChart from '../baseChartWidget'
  import chart from './chart'

  export default makeChart('invoicePaymentSpend-wdg-cmp', chart)
</script>



// WEBPACK FOOTER //
// src/components/_modules/Dashboard/widgets/InvoicePaymentStatus/index.vue